// Portal.js
import React from 'react';
import ReactDOM from 'react-dom';

const Portal = ({ children }) => {
  return ReactDOM.createPortal(
    children,
    document.getElementById('portal-root') // Ensure you have a div with id 'portal-root' in your index.html
  );
};

export default Portal;
